/** Utilitários de mídia compartilhados pela interface. */

import { h } from './dom.js';
import { toast } from './components.js';
import { ApiError, fetchBlobUrl } from '../api.js';
import type { MediaAsset, MediaKind } from '../types.js';

/** Ícone textual por tipo de mídia. */
export function kindIcon(kind: MediaKind): string {
  switch (kind) {
    case 'AUDIO':
      return '♪';
    case 'VIDEO':
      return '▶';
    case 'PLAYLIST':
      return '≡';
    case 'IMAGEM':
      return '▣';
    case 'PDF':
      return '▤';
    case 'SLIDES':
      return '◫';
    default:
      return '✎';
  }
}

/** Abre links externos em nova aba ou baixa o arquivo autenticado. */
export async function downloadAsset(asset: MediaAsset): Promise<void> {
  if (asset.externalUrl) {
    window.open(asset.externalUrl, '_blank', 'noopener');
    return;
  }
  if (!asset.fileUrl) {
    toast.error('Arquivo indisponível');
    return;
  }

  try {
    const url = await fetchBlobUrl(asset.fileUrl);
    const link = h('a', { href: url, download: asset.title });
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30_000);
  } catch (error) {
    toast.error('Falha ao baixar', error instanceof ApiError ? error.message : undefined);
  }
}
